import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>JayakornK FireGram</h1>
      <h2>Your Pictures</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </div>
  )
}

export default Title;
